import styled from 'styled-components'
import LandingPageHeading from './LandingPageHeading'
import CommonFormItem from './CommonForms/CommonFormItem'

const StyledCommonFormsModern = styled.div`
  background-color: #fff;
  padding: 40px 0;

  @media (min-width: ${({ theme }) => theme.breakPoints.medium}) {
    margin: 40px 0;
    position: relative;

    &:after,
    &:before {
      position: absolute;
      content: '';
      background: #fff;
      width: 100%;
      height: 40px;
    }
    &:after {
      bottom: -40px;
      height: 40px;
    }
    &:before {
      top: -40px;
      height: 40px;
    }

    .wrapper-common-forms {
      margin-top: 40px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;

      .item {
        margin-right: 15px;
      }
    }
  }
`

const forms = [
  {
    text: 'Partial Prepayment',
    href: '/forms/2024/Partial_Prepayment_Form.pdf',
  },
  {
    text: 'Occupancy Certification',
    href: '/forms/2024/Annual_Occupancy_Certificate.pdf',
  },
]

export const CommonFormsModern = () => {
  return (
    <StyledCommonFormsModern>
      <LandingPageHeading title="Common Forms" />
      <div className="wrapper-common-forms">
        {forms.map((item, index) => (
          <div className="item" key={index}>
            <CommonFormItem form={item} />
          </div>
        ))}
      </div>
    </StyledCommonFormsModern>
  )
}
